import React from 'react';

export default function CategoryCms({category}) {
    return (category.display_mode == 'PRODUCTS' || !category.cms_block?.content?.length)
        ? null
        : <div id="categoryCms" dangerouslySetInnerHTML={{__html: category.cms_block.content}} />
}
